"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RefreshTokenResponseSchema", {
    enumerable: true,
    get: function() {
        return RefreshTokenResponseSchema;
    }
});
const _tokenpair = require("./token-pair");
const RefreshTokenResponseSchema = _tokenpair.TokenPairSchema;
